import { motion } from 'motion/react'
import type { StatusPrioritiesItem } from '../../api/types'
import { TOKENS } from '../ui/dashboard-primitives'
import { Md } from './Md'

/**
 * The three things to do next, delivered by the mascot's fixed "lecture" pose.
 * The editorial spine stays on the canvas — no panel (self-contained readouts
 * get a surface, instructions do not).
 */
export function StatusPriorities({ priorities }: { priorities: StatusPrioritiesItem[] }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-[176px_1fr] gap-x-14 gap-y-8 items-start mt-2">
      <figure className="hidden md:block sticky top-24 m-0 pointer-events-none select-none">
        <img
          src="/images/yami-kuro-neutral.webp"
          width={394}
          height={640}
          alt=""
          aria-hidden="true"
          className="w-full h-auto"
          style={{ animation: 'yamiFloat 6.5s ease-in-out infinite' }}
        />
      </figure>

      <div>
        {priorities.map((p, i) => {
          const hot = p.severity === 'risk' || p.severity === 'warning'
          return (
            <motion.div
              key={p.rank}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="grid grid-cols-[3rem_1fr] gap-x-5.5"
              style={{
                padding: i === 0 ? '0 0 26px' : '26px 0',
                borderTop: i === 0 ? undefined : '1px solid ' + TOKENS.creamHairline,
              }}
            >
              <span
                className="text-[1.05rem] font-medium tabular-nums"
                style={{
                  fontFamily: 'var(--font-mono)',
                  letterSpacing: '-0.02em',
                  color: hot ? TOKENS.terracotta : TOKENS.creamFaint,
                }}
              >
                {String(p.rank).padStart(2, '0')}
              </span>
              <div>
                <h3
                  className="mb-2"
                  style={{
                    fontFamily: 'var(--font-display)',
                    fontWeight: 500,
                    fontSize: '1.1875rem',
                    letterSpacing: '-0.012em',
                    color: TOKENS.cream,
                  }}
                >
                  {p.title}
                </h3>
                <p className="text-[0.9375rem] leading-relaxed" style={{ color: TOKENS.creamSoft, maxWidth: '68ch' }}>
                  <Md boldMono>{p.body}</Md>
                </p>
              </div>
            </motion.div>
          )
        })}
      </div>
    </div>
  )
}
